import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const firstEpss = defineConnector({
  identifier: "firstEpss",
  name: "FIRST EPSS",
  tagLine: "Exploit prediction scoring",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.first.org/data/v1"),
  auth: headerAuth([]),
  steps: [
    {
      title: "Set up FIRST EPSS",
      items: [
        {
          kind: "markdown",
          content:
            "This public API requires no credentials. Use the default API URL. See the [EPSS API documentation](https://www.first.org/epss/api).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.first.org/data/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the fixed global FIRST API host; no tenant-specific or regional host is documented. FIRST’s API documentation identifies https://api.first.org/data/v1/epss as the EPSS resource URL. This connector base uses the documented /data/v1 API prefix and appends /epss for requests.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.first.org/data/v1")
          .trim()
          .replace(/\/+$/, "") + "/epss?cve=CVE-2022-27225",
      ...{ method: "GET" },
    }),
  },
});
